<template>
  <div class="buzz-script-wrap">
    <div ref="buzzStage" class="buzzplayer-stage" data-debug="true" data-width="100%"></div>
    <!-- <load v-if="loading"></load> -->
  </div>
</template>

<script>
import Axios from 'axios';
// import load from '@/components/loading.vue';

export default {
  name: 'buzzCode',
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return {
      player: null,
      jsondata: {},
      curId: this.id,
      loading: true,
    };
  },
  // components: {
  //   load,
  // },
  computed: {
  },
  methods: {
    getData() {
      const link = `/data/creatives/${this.curId}.json`;
      Axios
        .get(link)
        .then((response) => {
          this.jsondata = response.data.playerData;
          this.destroyPlayer();
          this.initPlayer(this.jsondata);
          // this.setUserAgent(window, 'Mozilla/5.0 (iPhone; CPU iPhone OS 13_2_3 like Mac OS X)
          // AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.3 Mobile/15E148 Safari/604.1');
        });
    },
    // setUserAgent(window, userAgent) {
    //   if (window.navigator.userAgent != userAgent) {
    //     var userAgentProp = { get: function () { return userAgent; } };
    //     try {
    //         Object.defineProperty(window.navigator, 'userAgent', userAgentProp);
    //     } catch (e) {
    //         window.navigator = Object.create(navigator, {
    //             userAgent: userAgentProp,
    //         });
    //     }
    //   }
    // },
    initPlayer(jsondata) {
      const data = { ...jsondata };
      data.unit_settings = {
        autoplay_enable_sound: false,
      };
      data.unit_settings_list = [
        'align',
        'clickunder_selector',
        'container_height',
        'debug_mode',
        'expandable',
        'fullscreen',
        'height',
        'overroll',
        'target',
        'width',
      ];
      this.player = new window.Buzzoola.Core(this.$refs.buzzStage, {
        notSendRequestCtor: true,
        data,
      });
      // this.player.on('remote_module_ready', () => {
      //   console.log("player ready");
      //   this.$emit('ready');
      // });
      this.player.on('core:ads_loaded', () => {
        // console.log("player ready");
        this.$emit('ready');
      });
    },
    destroyPlayer() {
      if (this.player) {
        this.player.destroy();
      }
    },
    // loadLib(src) {
    //   return new Promise((resolve) => {
    //     const script = document.createElement('script');
    //     script.src = src;
    //     script.onload = () => resolve();
    //     document.head.append(script);
    //   });
    // },
  },
  watch: {
    id() {
      if (this.$router.currentRoute.params.id !== this.curId) {
        this.curId = this.$router.currentRoute.params.id;
      }
      return this.curId;
    },
  },
  created() {
    this.getData();
    // this.loadLib('/vendor/buzzlibrary.js').then(() => {
    //   this.loadLib('/vendor/buzzlibrary_extra.js').then(() => {
    //   });
    // });
  },
  beforeUpdate() {
  },
  beforeDestroy() {
    this.destroyPlayer();
  },
  beforeCreate() {
  },
};
</script>

<style lang='stylus'>
  .weather__banner-container .buzz_widget
    background-size cover !important
  .pay__banner-container .buzz_widget
    background-size cover !important
</style>
